<!-- 课程管理 -->
<template>
  <!-- 查询输入框开始 -->
  <a-form
      ref="formRef"
      name="advanced_search"
      class="ant-advanced-search-form mySerachForm"
      :model="queryformState"
      @finish="onFinish"
    >
      <a-row :gutter="24">
      
        <a-col  :span="8">
            <a-form-item  name="name" label="课程名称" >
              <a-input class="input" v-model:value="queryformState.name" placeholder="请输入课程名称"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      <a-row>
        <a-col :span="24" style="text-align: right">
          <a-button type="primary" html-type="submit">查询</a-button>
          <a-button style="margin: 0 8px" @click="() => formRef.resetFields()">重置</a-button>
          <a-button type="primary" v-if="isShowAddModel"  @click="showModel">新增</a-button>
          <a-button style="margin: 0 8px" v-if="isShowAddModel"  @click="noticeTYJ">推送体育局</a-button>
          
        </a-col>
      </a-row>
    </a-form>

  <!-- 查询输入框结束 -->

  <a-table :columns="columns" :data-source="data" size="small" :pagination="false" bordered>
    <template #bodyCell="{ column, text, record }">
      <template v-if="['name', 'age'].includes(column.dataIndex)">
        <div>
          <a-input
            v-if="editableData[record.id]"
            v-model:value="editableData[record.id][column.dataIndex]"
            style="margin: -5px 0"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template v-else-if="column.dataIndex === 'operation'">
        <div class="editable-row-operations">
         
          <span v-if="isShowAddModel">

             <a v-if="record.status == '0'"   @click="onDelete(record.id)">删除</a>
             <a  @click="onEdit(record)">编辑</a>
             
          </span>
        </div>
      </template>
    </template>
  </a-table>
  <a-pagination class="pagination" v-model:current="current" v-model:total="total"  v-model:pageSize="pageSize" :hideOnSinglePage="true" @change="onChange" @showSizeChange="showSizeChange" />
  
  <!-- 可编辑表格结束 -->


  <!-- 新增页面开始 -->
  <a-modal
      v-model:visible="visible"
      :title="saveFormState.id ?'编辑课程':'新增课程'"
      ok-text="提交"
      :width="1200"
      cancel-text="取消"
      @ok="submitCurriculum"
      @cancel="afterClose"
    >
      <a-form ref="saveFormRef" :model="saveFormState"   layout="horizontal" name="user_form_in_modal">
        <a-row :gutter="24">
          <a-col  :span="12">
          <a-form-item  label="课程名称" name="name" :rules="[{ required: true, message: '请输入课程名称' }]">
          <a-input   v-model:value="saveFormState.name" />
        </a-form-item>
</a-col>
<a-col  :span="12">
        <a-form-item label="机构名称" name="team_id" :rules="[{ required:false, message: '请输入机构' }]">
          <a-select v-model:value="saveFormState.team_id" @change="handleChangeTeam">
            <a-select-option value="">请选择</a-select-option>
		        <a-select-option v-for="item in teamNameList" :value="item.team_id" :key="item.team_id" :label="item.team_name">
			        {{ item.team_name }}
		        </a-select-option>
	        </a-select>
        </a-form-item></a-col>

        <a-col  :span="12">
        <a-form-item label="课程分类" name="kcclassify" :rules="[{ required:true, message: '请选择课程分类' }]">
          
          <a-select v-model:value="saveFormState.kcclassify" @change="handleChangeStatus2">        
                  <a-select-option value="1">讲座类</a-select-option>
                  <a-select-option value="2">技能类</a-select-option>
	        </a-select>
        </a-form-item>
      </a-col>


        <a-col  :span="12">
        <a-form-item label="授课老师" name="teacher_id" :rules="[{ required:false, message: '请输入授课老师' }]">
          <a-select v-model:value="saveFormState.teacher_id" @change="handleChange">
		        <a-select-option v-for="item in teacherNameList" :value="item.teacher_id" :key="item.teacher_id" :label="item.teacher_name">
			        {{ item.teacher_name }}
		        </a-select-option>
	        </a-select>
        </a-form-item></a-col>

       
      <a-col  :span="12">
        <a-form-item label="课程状态" name="status" :rules="[{ required:true, message: '请选择课程状态' }]">
          
          <a-select v-model:value="saveFormState.status" @change="handleChangeStatus3">        
                  <a-select-option value="0">正常</a-select-option>
                  <a-select-option value="1">删除</a-select-option>
                  
	        </a-select>


        </a-form-item>
      </a-col>
      <a-col  :span="24">

<!--   
         <a-form-item label="课程介绍" name="kcdescribe" :rules="[{ required:true, message: '请输入课程介绍' }]">
            
      <textarea
 v-model="saveFormState.kcdescribe"
placeholder="请输入课程介绍"
  rows="4"
  style="width: 100%; padding: 8px; border: 1px solid #ddd;" />
          </a-form-item>
           -->




        <a-form-item
          label="课程介绍"
          name="kcdescribe"
          :rules="[{ required: true, message: '请输入课程介绍', trigger: 'change' }]"
        >
          <Toolbar
            :editor="editor1"
            :defaultConfig="toolbarConfig1"
            style="border-bottom: 1px solid #e8e8e8"
          />
          <Editor
           v-model="saveFormState.kcdescribe"
            :editor="editor1"
            :defaultConfig="editorConfig1"
            @onCreated="handleEditorCreatedkcdescribe"
            @onChange="handleEditorChangekcdescribe"
            style="height: 300px; overflow-y: auto;"
          />
        </a-form-item> 

      </a-col>
      <a-col  :span="24">

<!-- 
 <a-form-item label="预约条件" name="kcconditions" :rules="[{ required:true, message: '请输入预约条件' }]">
      <textarea
 v-model="saveFormState.kcconditions"
placeholder="请输入预约条件"
  rows="4"
  style="width: 100%; padding: 8px; border: 1px solid #ddd;" />
   </a-form-item>
      -->

       
        <a-form-item
          label="预约条件"
          name="kcconditions"
          :rules="[{ required: true, message: '请输入内容', trigger: 'change' }]"
        >
          <Toolbar
            :editor="editor"
            :defaultConfig="toolbarConfig"
            style="border-bottom: 1px solid #e8e8e8"
          />
          <Editor
           v-model="saveFormState.kcconditions"
            :editor="editor"
            :defaultConfig="editorConfig"
            @onCreated="handleEditorCreated"
            @onChange="handleEditorChange"
            style="height: 300px; overflow-y: auto;"
          />
        </a-form-item> 
      </a-col>
      <a-col  :span="8">
        <a-form-item name="imgurl" label="课程图片" extra="请上传课程banner">
              <a-upload
                v-model:fileList="saveFormState.upload"
                :custom-request="customUploadRequest"
                list-type="picture"
              >
                <a-button>
                  <template #icon><UploadOutlined /></template>
                  上传文件
                </a-button>
              </a-upload>
            </a-form-item>
            </a-col>
            </a-row>
      </a-form>
    </a-modal>

  <!-- 新增页面结束 -->


</template>
<script setup>
import { cloneDeep, value } from 'lodash-es';
import axios from  'axios'
import {message} from 'ant-design-vue'
import {reactive, ref,toRefs,onMounted,shallowRef, watch, onBeforeUnmount } from 'vue'
// 正确导入 Editor 和 Toolbar 组件
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import '@wangeditor/editor/dist/css/style.css';
import moment from 'moment'; // 需要引入 moment 库
import { $fetchTeacherOptions,$getCurriculumList,$submitCurriculum ,$deleteKeCheng,$fetchTeamOptions,$noticeTYJ} from '../api/course.js';
import { $uploadCert } from '../api/systemTeacher.js';
import {baseUrl} from '../utils/const'
//************************************ */

// 编辑器实例
const editor = shallowRef(null);
const editor1 = shallowRef(null);
// 表单模型（必须包含与a-form-item的name对应的属性）
const formState = ref({
  title: '',
  content: ''  // 与富文本字段的name="content"对应
});
const formState1 = ref({
  title: '',
  content: ''  // 与富文本字段的name="content"对应
});
// 富文本验证状态
const contentValidateStatus = ref('');
const contentHelp = ref('');
// 配置：限制图片大小（MB）
const MAX_IMAGE_SIZE = 5; // 5MB
// 支持的图片类型
const SUPPORTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'];
// 上传相关配置
const uploadConfig = {
  // 图片上传接口地址
  imageUploadUrl: baseUrl+'/ajaxUpload.do',
  // 视频上传接口地址
  videoUploadUrl: baseUrl+'/uploadVideo.do',
  // 文件上传接口地址
  fileUploadUrl: baseUrl+'/uploadFile.do',
  // 上传请求头
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    // 可添加认证信息
    // 'Authorization': `Bearer ${token}`
  },
  // 上传文件大小限制（MB）
  imageMaxSize: 5,
  videoMaxSize: 50,
  fileMaxSize: 20
};
// 表单验证规则
const formRules = {
  title: [
    { required: true, message: '请输入标题', trigger: 'blur' }
  ]
};
// 工具栏配置 - 只保留最基础的文本操作功能
const toolbarConfig = {
  toolbarKeys: [
    // 文本格式化
    'bold',       // 加粗
    'italic',     // 斜体
    'underline',  // 下划线
    'through',    // 删除线
    '|',
    // 标题
    'header1',    // 标题1
    'header2',    // 标题2
    'header3',    // 标题3
    '|',
    // 列表
    'bulletedList', // 无序列表
    'numberedList', // 有序列表
    '|',
    // 对齐方式
    'justifyLeft',  // 左对齐
    'justifyCenter',// 居中对齐
    'justifyRight', // 右对齐
    '|',
   // 'uploadImage', '|', // 只保留图片上传按钮
    // 撤销重做
    'undo',       // 撤销
    'redo'        // 重做
  ]
};
const toolbarConfig1 = {
  toolbarKeys: [
    // 文本格式化
    'bold',       // 加粗
    'italic',     // 斜体
    'underline',  // 下划线
    'through',    // 删除线
    '|',
    // 标题
    'header1',    // 标题1
    'header2',    // 标题2
    'header3',    // 标题3
    '|',
    // 列表
    'bulletedList', // 无序列表
    'numberedList', // 有序列表
    '|',
    // 对齐方式
    'justifyLeft',  // 左对齐
    'justifyCenter',// 居中对齐
    'justifyRight', // 右对齐
    '|',
    //'uploadImage', '|', // 只保留图片上传按钮
    // 撤销重做
    'undo',       // 撤销
    'redo'        // 重做
  ]
};
// 编辑器配置 - 彻底禁用所有上传和复杂功能
const editorConfig = {
  placeholder: '请输入内容...',
  // 禁用所有可能涉及上传的功能
  MENU_CONF: {
    uploadImage: { disabled: true },
    // uploadImage: {
    //   // 自定义上传
    //   async customUpload(file, insertFn) {
    //     uploadFile({
    //       file,
    //       url: uploadConfig.imageUploadUrl,
    //       maxSize: uploadConfig.imageMaxSize,
    //       accept: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    //       onSuccess: (url) => {
    //         // 插入图片到编辑器
    //         insertFn(url, file.name, file.size);
    //       }
    //     });
    //   }
    // },
    uploadVideo: { disabled: true },
    uploadFile: { disabled: false },
    insertLink: { disabled: true },    // 禁用链接
    insertTable: { disabled: true },   // 禁用表格
    codeBlock: { disabled: true },     // 禁用代码块
    code: { disabled: true },          // 禁用行内代码
    emotion: { disabled: true },       // 禁用表情
    divider: { disabled: true },       // 禁用分割线
    fullScreen: { disabled: true }     // 禁用全屏
  }
};
const editorConfig1 = {
  placeholder: '请输入内容...',
  // 禁用所有可能涉及上传的功能
  MENU_CONF: {
     uploadImage: { disabled: true },
    // uploadImage: {
    //   // 自定义上传
    //   async customUpload(file, insertFn) {
    //     uploadFile({
    //       file,
    //       url: uploadConfig.imageUploadUrl,
    //       maxSize: uploadConfig.imageMaxSize,
    //       accept: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    //       onSuccess: (url) => {
    //         // 插入图片到编辑器
    //         insertFn(url, file.name, file.size);
    //       }
    //     });
    //   }
    // },
    uploadVideo: { disabled: true },
    uploadFile: { disabled: false },
    insertLink: { disabled: true },    // 禁用链接
    insertTable: { disabled: true },   // 禁用表格
    codeBlock: { disabled: true },     // 禁用代码块
    code: { disabled: true },          // 禁用行内代码
    emotion: { disabled: true },       // 禁用表情
    divider: { disabled: true },       // 禁用分割线
    fullScreen: { disabled: true }     // 禁用全屏
  }
};

// 通用上传函数
const uploadFile = async ({ file, url, maxSize, accept = [], onSuccess }) => {
  // 验证文件类型
  if (accept.length > 0 && !accept.includes(file.type)) {
    message.error(`不支持的文件类型，仅支持${accept.join('、')}`);
    return;
  }

  // 验证文件大小
  if (file.size > maxSize * 1024 * 1024) {
    message.error(`文件大小不能超过${maxSize}MB`);
    return;
  }

  try {
    // 创建FormData
    const formData = new FormData();
    formData.append('file', file);
    
    // 显示上传中提示
    const hide = message.loading('上传中...', 0);
    
    // 调用上传接口
    const response = await axios.post(url, formData, {
      headers: {
        ...uploadConfig.headers,
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        // 可以在这里处理上传进度
        const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        console.log(`上传进度: ${percent}%`);
      }
    });
    
    // 关闭加载提示
    hide();
    console.log("上传应答")
    console.log(response)
    // 假设接口返回格式: { code: 200, data: { url: 'xxx' } }
    if (response.data.code === "success") {
      message.success('上传成功');
      onSuccess(response.data.msg);
    } else {
      message.error(response.data.msg || '上传失败');
    }
  } catch (error) {
    message.error('上传接口调用失败');
    console.error('上传错误:', error);
  }
};

// 将图片文件转为Base64的工具函数
const convertImageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    // 读取文件并转为DataURL（Base64格式）
    reader.readAsDataURL(file);
    
    // 读取成功回调
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result); // 结果格式：data:image/png;base64,xxxxxx
      } else {
        reject(new Error('Base64转换失败'));
      }
    };
    
    // 读取失败回调
    reader.onerror = () => {
      reject(reader.error);
    };
  });
};
// 编辑器初始化
const handleEditorCreated = (inst) => { editor.value = inst; };
const handleEditorCreatedkcdescribe = (inst) => { editor1.value = inst; };
// 富文本变化时触发表单验证
const handleEditorChange = () => {
  saveFormRef.value?.validateFields(['kcconditions']);
};
const handleEditorChangekcdescribe = () => {
  saveFormRef.value?.validateFields(['kcdescribe']);
};

// 表单提交（自动验证）
const handleFinish = (values) => {
  message.success('提交成功');
};

// 手动验证（重点：正确处理错误对象）
const handleManualValidate = () => {
  
};

// 组件卸载时清理
onBeforeUnmount(() => {
  editor.value?.destroy();
  editor1.value?.destroy();
});
//************************************ */
const teacherNameList = ref([]);
const teamNameList = ref([]);
const handleChange = (value, option) => {
  const selectedKey = option.key; // 或者使用 option.value 获取 key
  const selectedText = option.label; // 获取文本
  console.log("selectedKey="+selectedKey)
  console.log("selectedText="+selectedText)
  saveFormState.teacher_id=selectedKey
  saveFormState.teacher_name=selectedText
}
//定义一个缓存
const childDataCache = ref({});
const handleChangeTeam = async (value,option) =>{
  const selectedKey = option.key; // 或者使用 option.value 获取 key
  const selectedText = option.label; // 获取文本
  console.log("selectedKey="+selectedKey)
  console.log("selectedText="+selectedText)
  saveFormState.team_id=selectedKey
  saveFormState.team_name=selectedText;

  //子级的值，置空
  saveFormState.teacher_id='';
  saveFormState.teacher_name='';
  if(selectedKey==''|| selectedKey==null|| selectedKey=="null"){//不选择的时候
    teacherNameList.value =[]
    return;
  }
  // 先检查缓存
  if(childDataCache.value[selectedKey]) {
    teacherNameList.value = childDataCache.value[selectedKey];
    return;
  }
  //缓存没有，在查询接口
  if(selectedKey==''|| selectedKey==null|| selectedKey=="null"){//不选择的时候

  }else{
    fetchTeacherOptions();
  }
  

}
const handleChangeStatus3=(value, option) => {
  const selectedKey = option.key; 
  console.log("value="+value)
  console.log("selectedKey="+selectedKey)

  saveFormState.status=value

}



const isShowAddModel=ref(false)
// 组件挂载时获取数据
onMounted(() => {
 // fetchTeacherOptions();
 let userInfo=JSON.parse(localStorage.getItem("userInfo"));
  if(userInfo.team_id == 'admin'){
    isShowAddModel.value=true;
  }
 fetchTeamOptions();
});
const fetchTeamOptions = async () => {
  let res=await $fetchTeamOptions();
  console.log(res)
  if(res.code=='success'){
   const data =res.data;
   teamNameList.value=res.data;
   saveFormState.team_id=data[0].team_id
   saveFormState.team_name=data[0].team_name
    console.log(saveFormState.team_id)
    fetchTeacherOptions();
  }
};
// 从接口获取选项数据
const fetchTeacherOptions = async () => {
  const team_id= saveFormState.team_id;
  console.log("根据team_id查询老师："+team_id);
  if(!team_id){
      return ;
  }
  let res=await $fetchTeacherOptions(team_id);
  console.log(res)
  if(res.code=='success'){
   const data =res.data;
   teacherNameList.value=res.data;
   saveFormState.teacher_id=data[0].teacher_id
   saveFormState.teacher_name=data[0].teacher_name
    console.log(saveFormState.teacher_id)
  }
};
const formRef = ref();
const saveFormRef = ref();
const visible = ref(false);
const detailVisible=ref(false)
const showModel = () => {
  saveFormState.id=""
  reset();
  visible.value = true;
}
const noticeTYJ=()=>{
  console.log("推送体育局");

  let res=$noticeTYJ(saveFormState);
  
    message.error("已经发起推送，不要重复点击推送")
  
}
const saveFormState=reactive({
  id:'',//id,
  name:'',//name,//课程名称
  teacher_id:'',
  teacher_name:'',//teacher_name,//授课老师
  team_id:"",
  team_name:"",
  kcclassify:'',//status,//课程分类
  kcdescribe:'',//address,//课程介绍
  kcconditions:'',//memo,//预约条件
  upload:[],
  imgurl:"",
  status:"",
})


//编辑按钮。根据id查询信息
const onEdit=async (data)=>{
 console.log(data)
    //赋值，并显示
    saveFormState.id=data.id;
    saveFormState.name=data.name;//课程名称
    saveFormState.teacher_id=data.teacher_id;
    saveFormState.teacher_name=data.teacher_name;//授课老师
    saveFormState.kcclassify=data.kcclassify;
    saveFormState.kcdescribe=data.kcdescribe;//预约联系人
    saveFormState.kcconditions=data.kcconditions;//联系人电话
    saveFormState.upload=JSON.parse(data.upload);
    saveFormState.team_id=data.team_id;
    saveFormState.team_name=data.team_name;
    saveFormState.status=data.status;
    saveFormState.imgurl=data.imgurl;
    visible.value = true;

}


const reset=()=>{
  saveFormState.id="";
    saveFormState.name="";
    saveFormState.teacher_id="";
    saveFormState.teacher_name="";
    saveFormState.kcclassify="";
    saveFormState.kcdescribe="";
    saveFormState.kcconditions="";
    saveFormState.upload=[]

    saveFormState.status="";
    saveFormState.imgurl="";
}

//删除
let onDelete=async (id)=>{
  let res=await $deleteKeCheng({id})
  // console.log(res)
  if(res.code=='success'){
      message.success(res.msg)
      //再次查询
      loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  }else{
    message.error(res.msg);
  }
}

const handleCancel=()=>{
  saveFormRef.value.resetFields();
  detailVisible.value=false;
}

const afterClose=()=>{
  saveFormRef.value.resetFields();
  visible.value=false;
}
const submitCurriculum =async () => {
  console.log(saveFormState);

  if (!saveFormRef.value) return;
  try {
  saveFormRef.value.validateFields(null, { first: false })
    .then(async () => {
     
    //  message.success('验证通过');
      let res=await $submitCurriculum(saveFormState);
  if(res.code=='success'){
    
   visible.value = false;
  
    //在调用一次列表查询的方法
   loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  }else{
    message.error(res.msg)
  }
    })
    .catch(errorInfo => {
      // 关键修复：解析错误对象，避免直接抛出[object Object]
      console.error('验证失败:', errorInfo);
      message.error('请填写必填内容');
    });
  } catch (errorInfo) {
    console.error('验证失败:', errorInfo);
  }

 
}

/**
 * 上传图片方法2：将图片转成base64的方式，当做成一个普通的字符串进行提交，使用统一封装的axios工具类request.js
 * @param param0 
 */
 const customUploadRequest =async ({ file, onSuccess, onError, onProgress }) => {
  console.log("自定义上传图片开始");
  const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload =async () => {
      const base64String = reader.result;
        const param={
          "imgBase64Data":base64String,
          "fileName":file.name,
        }
      let res=await $uploadCert(param);
      if(res.code=='success'){
        onSuccess(res);  // 上传成功回调
        saveFormState.imgurl=res.msg
      }else{
        onError(res.msg);  // 上传失败回调
      }
    };

    reader.onerror = (error) => {
      onError(error);
    };
    
}

// 提交查询按钮
const onFinish = values => {
 loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
};



const queryformState = reactive({
  name: '',
  
});




const kcclassifyMap = {
  
  "1": '讲座类',
  "2": '技能类',
};

const statusMap={
  "0": '正常',
  "1": '删除',
}

        
const columns = [
{
    title: '课程ID',
    dataIndex: 'id',
    width: '5%',
  },
{
    title: '课程名称',
    dataIndex: 'name',
    width: '10%',
  },
  {
    title: '机构名称',
    dataIndex: 'team_name',
    width: '10%',
  }, {
    title: '授课老师',
    dataIndex: 'teacher_name',
    width: '10%',
  },
  // {
  //   title: '课程图片',
  //   dataIndex: 'imgurl',
  //   width: '10%',
  //   key:"imgurl",
  //   customRender: (value, record) => {
  //     // 构建完整的img标签
     
  //     const imgHtml = `<img 
  //             src="${value}" 
  //             alt="课程图片" 
  //             style="width: 60px; height: 80px; object-fit: cover; border: 1px solid #eee;"
  //             onerror="this.src='https://picsum.photos/200/300?random=1'; this.onerror=null;"
  //           />`;
  //     return {
  //             // 使用domPropsInnerHTML确保HTML被解析
  //             domProps: {
  //               innerHTML: imgHtml
  //             }
  //           };
  //   },
  // },
  {
    title: '课程分类',
    dataIndex: 'kcclassify',
    width: '10%',
    key:"kcclassify",
    customRender: ({ value }) => {

      // 若状态码不存在，显示“未知”
      return kcclassifyMap[value] || '未知';
    },
  },
  // {
  //   title: '课程介绍',
  //   dataIndex: 'kcdescribe',
  //   width: '15%',
  // },
  // {
  //   title: '预约条件',
  //   dataIndex: 'kcconditions',
  //   width: '15%',
  // },
  {
    title: '课程状态',
    dataIndex: 'status',
    width: '5%',
    key:"status",
    customRender: ({ value }) => {
        
      // 若状态码不存在，显示“未知”
      return statusMap[value] || '未知';
    },
  },
  
  {
    title: '操作',
    dataIndex: 'operation',
    width: '10%',
    
  },
];
let tableData =reactive({
        data:[],
        currentDetailData:[],
        current:ref(1),
        total:ref(1),
        pageSize:10
});
//查询数据库
let loadData=async (params)=>{
  params.name=queryformState.name;
  
  let res=await $getCurriculumList(params);
  if(res.code=='success'){
      //取出数据data和总页数，分页使用
      console.log(res)
      let {total,pageSize,pageNo,list}=res.data
      tableData.data=list
      tableData.current=ref(pageNo)
      tableData.total=ref(total)
      tableData.pageSize=ref(pageSize)
  }
}
loadData({pageNo:1,pageSize:10}); 
let {data,current,total,pageSize,currentDetailData} =toRefs(tableData)

const dataSource = ref(data);
const editableData = reactive({});
const edit = key => {
  console.log('key:'+(key-1))
  editableData[key] = cloneDeep(dataSource.value.filter(item => key === item.id)[0]);
};
const save =async (key) => {
  Object.assign(dataSource.value.filter(item => key === item.id)[0], editableData[key]);
  let res=await $updateYuyue(editableData[key]);
  delete editableData[key];
  if(res.code=='success'){
    message.success('保存成功')
    loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  }else{
    message.error('保存失败')
  }
};
const cancel = key => {
  delete editableData[key];
};


function onChange(page, pageSize) {
  let params= {pageNo:page,pageSize:pageSize}
  loadData(params);
}
function showSizeChange(current, size){
  let params= {pageNo:current,pageSize:size}
  loadData(params);
}
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.pagination{
  margin-top: 40px;
  float: right;
}

.mySerachForm{
  margin-bottom: 20px;
  
  
}
.input{
    border-radius: 2px;
  }
  .onEdit{
    margin-left: 10px;
  }
  .form-with-rich-text {
  max-width: 1000px;
  margin: 20px auto;
  padding: 0 20px;
}

.submitted-content {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  min-height: 100px;
}


.rich-text-form-container {
  max-width: 1000px;
  margin: 20px auto;
  padding: 0 20px;
}

.preview-content {
  min-height: 200px;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  line-height: 1.8;
}

/* 编辑器样式调整 */
:deep(.w-e-toolbar) {
  border-bottom: 1px solid #e8e8e8 !important;
  flex-wrap: wrap;
}

:deep(.w-e-text-container) {
  border: none !important;
}
</style>